import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from 'react-redux';
import { Alert, AlertColor } from '@mui/material';
import { AppActions } from '../../store/AppReducer';
import { RootStateType } from '../../store/RootReducer';
import Status404 from 'src/content/pages/Status/Status404';
import { AppUser } from 'src/models/appUser';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

interface RequireAuthProps {
  childCompoenent: React.ReactNode;
  tabname: string;
}

export const RequireAuth: React.FC<RequireAuthProps> = (chidlProp, tab) => {
  //props: React.PropsWithChildren<RequireAuthProps>

  const { childCompoenent } = chidlProp;
  const { tabname } = tab;

  //  const snackbarSeverity = useSelector((state: RootStateType) => state.appReducer.snackBar.severity);

  //  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isAuth, setAuth] = React.useState(true);
  const appUser = useSelector((state: RootStateType) => state.appReducer.user);

  useEffect(() => {
    appUser == null ? setAuth(false) : setAuth(true);
  }, [appUser]);

  return (
    <>
      {isAuth ? (
        <>{childCompoenent}</>
      ) : (
        <>
          <Status404 />
        </>
      )}
    </>
  );
};
